import {Link} from "react-router-dom";
import {Space, Breadcrumb, Row, Col, Divider} from 'antd';
import JobDetail from "../components/JobDetail";


export default function PageDetail() {

    return (
        <>
                <Row gutter={16}>
                    <Col className="gutter-row" span={24}>
                        <Breadcrumb
                            items={[
                                {
                                    title: <Link to={'/'}>Dashboard</Link>,
                                },
                                {
                                    title: 'Job',
                                },
                            ]}
                        />
                    </Col>
                </Row>
            <Divider/>
                <Row gutter={16}>
                    <Col className="gutter-row" span={24}>
                        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                        <JobDetail />
                        </Space>
                    </Col>
                </Row>
        </>
    );
}